<template>
  <b-button
    :outlined="isOutlined"
    :type="color"
    :size="size"
    :class="{'is-short': isShort}"
    :icon-left="iconLeft"
    :icon-right="iconRight"
    :loading="loading || asyncLoading"
    :disabled="asyncLoading || disabled"
    @click="clicked"
  >
    <slot></slot>
  </b-button>
</template>

<script>
export default {
  name: "ButtonDefault",
  props: {
    asyncClick: {
      type: Function,
    },
    size: {
      type: String,
      default: 'is-small'
    },
    color: {
      type: String,
      default: 'is-primary'
    },
    iconLeft: {
      type: String,
    },
    iconRight: {
      type: String,
    },
    loading: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isShort: {
      type: Boolean,
      default: false,
    },
    isOutlined: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      asyncLoading: false,
    }
  },
  methods: {
    clicked(event) {
      this.$emit('click', event);

      if (this.asyncClick) {
        this.asyncLoading = true;
        this.asyncClick()
          .then(response => {
            return response;
          })
          .catch((response)=> {
            return response;
          })
          .finally(() => this.asyncLoading = false);
      }
    }
  }
}
</script>
